
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import {
  getCurrentInstance,
  onMounted,
  ref,
  toRefs
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { Form, Field, FieldArray, ErrorMessage, useForm } from 'vee-validate'
import { isNull } from 'lodash'
import Checkbox from 'primevue/checkbox'
import * as Yup from 'yup'
import Dropdown from 'primevue/dropdown'

export default {
  components: {
    Dialog,
    // Form,
    // Field,
    // FieldArray,
    // Checkbox,
    InputText,
    Button,
    Dropdown
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    ritData: {
      default: null as any
    }
  },
  emits: ['hideScheduleForm', 'onSubmit'],
  setup(props: any, { emit }: any) {
    const app = getCurrentInstance()
    const {
      $toast
    } = app!.appContext.config.globalProperties
    const store = useStore()
    const isLoading = ref(true)
    const { show, ritData } = toRefs(props)
    const showModal = show.value
    const dataSource = ref([]) as any
    const dataSourceTemp = ref([]) as any
    const dataLatestRevision = ref() as any
    const dataForm = ref([]) as any
    const isCrossdayValue = ref(false)

    const dayOffsetOptions = ref([
      { name: '+0', value: 0 },
      { name: '+1', value: 1 },
      { name: '+2', value: 2 },
      { name: '+3', value: 3 },
      { name: '+4', value: 4 },
      { name: '+5', value: 5 },
      { name: '+6', value: 6 },
      { name: '+7', value: 7 },
      { name: '+8', value: 8 },
      { name: '+9', value: 9 },
    ])

    const endpoint = '/management/v1/MsRoute'

    const getDetail = async () => {
      store.dispatch('showLoading')
      dataSourceTemp.value = []
      await apiUseCase.get(`${endpoint}/${ritData.value.ritId}`).then((response) => {
        if (!response.error) {
          // console.log('response', response)
          // eslint-disable-next-line array-callback-return
          response.result.Terminal.map((data: any) => {
            const obj = {
              terminalId: data.MsStationId,
              name: data.Name,
              cityName: data.CityName,
              departure: null,
              arrival: null,
              dayOffset: 0,
              routeDetailId: data.MsRouteDetailId
            }
            dataSourceTemp.value.push(obj)
          })
          // console.log('dataSource', dataSourceTemp.value)
        }
      })
      dataSource.value = ritData?.value.data?.detailTerminals.length > 0 ? ritData?.value.data?.detailTerminals : dataSourceTemp.value
      isCrossdayValue.value = ritData?.value?.data?.isCrossDay
      isLoading.value = false
      store.dispatch('hideLoading')
    }

    const closeDialog = () => {
      emit('hideScheduleForm')
    }

    const checkdataFormAfterSubmit = (datas: any) => {
      datas.forEach((data: any, index: any) => {
        if ((index === 1 && !data.arrival) || (index === index.length - 1 && !data.departure) || !data.departure || !data.arrival) {
          $toast.add({
            severity: 'error',
            summary: 'Gagal',
            detail: 'Silahkan lengkapi jadwal terlebih dahulu',
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      })
    }

    const checkPayload = (datas: any) => {
      let val = true
      // eslint-disable-next-line consistent-return
      datas.forEach((data: any, index: any) => {
        if (val) {
          if ((index > 0 && !data.arrival) || (index < index.length - 2 && !data.departure)) {
            // console.log('xxx')
            $toast.add({
              severity: 'error',
              summary: 'Gagal',
              detail: 'Silahkan lengkapi jadwal terlebih dahulu',
              group: 'bc',
              closable: false,
              life: 3000
            })
            val = false
          }
          if (index > 0) {
            if (datas[index].dayOffset < datas[index - 1].dayOffset) {
              $toast.add({
                severity: 'error',
                summary: 'Gagal',
                detail: 'Jam pada Jadwal tidak valid. Mohon untuk periksa jadwal kembali',
                group: 'bc',
                closable: false,
                life: 3000
              })
              val = false
            } else if (datas[index].dayOffset === datas[index - 1].dayOffset) {
              if ((datas[index].arrival <= datas[index - 1].departure) || (data.arrival >= data.departure)) {
                $toast.add({
                  severity: 'error',
                  summary: 'Gagal',
                  detail: 'Jam pada Jadwal tidak valid. Mohon untuk periksa jadwal kembali',
                  group: 'bc',
                  closable: false,
                  life: 3000
                })
                val = false
              }
            // } else if (datas[index].dayOffset > datas[index - 1].dayOffset) {
            //   if (data.arrival >= data.departure) {
            //     $toast.add({
            //       severity: 'error',
            //       summary: 'Gagal3',
            //       detail: 'Jam pada Jadwal tidak valid. Mohon untuk periksa jadwal kembali',
            //       group: 'bc',
            //       closable: false,
            //       life: 3000
            //     })
            //     val = false
            //   }
            }
          }
        }
        console.log('val', val)
      })
      return val
    }

    const onSubmitAct = () => {
      // console.log('sbumit', dataSource.value)
      store.dispatch('showLoading')
      let isValid = true
      // console.log('isValid', checkPayload(dataSource.value))
      isValid = checkPayload(dataSource.value)
      if (isValid) {
        const obj = {
          data: dataSource.value,
          // ...ritData.value
          busOrder: ritData.value.busOrder,
          ppOrder: ritData.value.ppOrder,
          ritOrder: ritData.value.ritOrder,
          isCrossDay: dataSource.value.some((d: any) => d.dayOffset > 0)
        }
        // console.log('obj', obj)
        emit('onSubmit', obj)
      }
      store.dispatch('hideLoading')
    }

    onMounted(() => {
      // console.log('rit', ritData.value)
      getDetail()
    })

    return {
      isLoading,
      showModal,
      closeDialog,
      dataSource,
      onSubmitAct,
      isCrossdayValue,
      dayOffsetOptions
    }
  }
}
